module.exports = __webpack_public_path__ + "static/img/user-info-bg.9b3ecf8.png";


//////////////////
// WEBPACK FOOTER
// ./src/layout/layout/images/user-info-bg.png
// module id = lwXv
// module chunks = 7